import { DotDivider } from './DotDivider';
import { LineDivider } from './LineDivider';

export const Divider = {
  Dot: DotDivider,
  Line: LineDivider,
};
